<div>
    <div class="row">
        <div class="col-xl-12">
            <div class="card-box">
                <div v-if="!loadingFromApi">
                    <form @submit.prevent="onAddOrEditCustomerDiscountGroupSaveClick">
                        <div class="form-group">
                            <label for="depotSelect">
                                Depot
                            </label>
                            <div class="text-danger" v-if="customerDiscountGroupAddEditForm.customerDiscountGroup.depotId.hasError">
                                {{customerDiscountGroupAddEditForm.customerDiscountGroup.depotId.errorMessage}}
                            </div>
                            <bootstrap-select  :selectOptions="depots" :selectedOption="customerDiscountGroupAddEditForm.customerDiscountGroup.depotId.value" :elementId="'depotSelect'"
                                               :returnSelectedOptionText="true"
                                               @changeSelect="onDepotSelect"></bootstrap-select>
                        </div>
                        <div class="form-group">
                            <label for="nameInput">
                                Name
                            </label>
                            <div class="text-danger" v-if="customerDiscountGroupAddEditForm.customerDiscountGroup.name.hasError">
                                {{customerDiscountGroupAddEditForm.customerDiscountGroup.name.errorMessage}}
                            </div>
                            <input type="text" class="form-control" id="nameInput" v-model="customerDiscountGroupAddEditForm.customerDiscountGroup.name.value"/>
                        </div>
                        <div class="form-group">
                            <label for="discountAmountInput">
                                Discount Amount
                            </label>
                            <div class="text-danger" v-if="customerDiscountGroupAddEditForm.customerDiscountGroup.discountAmount.hasError">
                                {{customerDiscountGroupAddEditForm.customerDiscountGroup.discountAmount.errorMessage}}
                            </div>
                            <currency-input class="form-control" v-model="customerDiscountGroupAddEditForm.customerDiscountGroup.discountAmount.value"
                                            @change="onDiscountAmountChange"
                                            :options="{ currency: 'ZAR', currencyDisplay: 'narrowSymbol', autoDecimalDigits: true, hideCurrencySymbolOnFocus: false }"></currency-input>

                        </div>
                        <div class="form-group">
                            <label for="priceActiveDatePicker">
                                Date for Depot Discount Group to be active from
                            </label>
                            <div class="text-danger" v-if="customerDiscountGroupAddEditForm.customerDiscountGroup.effectiveDate.hasError">
                                {{customerDiscountGroupAddEditForm.customerDiscountGroup.effectiveDate.errorMessage}}
                            </div>
                            <date-picker aria-describedby="newPriceActiveDateHelp" :format="'DD/MM/YYYY'" :elementId="'priceActiveDatePicker'"
                                         :date="customerDiscountGroupAddEditForm.customerDiscountGroup.effectiveDate.value"
                                         :initialiseDate="initialiseDate"
                                         @dateChange="onEffectiveDateSelected"></date-picker>
                            <small id="newPriceActiveDateHelp" class="form-text text-muted">
                                Enter the day new depot discount group will be active from
                            </small>
                        </div>

                        <div>
                            <h5>Link Customers to Depot Discount Group</h5>
                            <div class="text-danger">
                                {{customerDiscountGroupAddEditForm.customerDiscountGroup.linkedCustomers.errorMessage}}
                            </div>
                            <button class="btn btn-primary float-right" @click.prevent="onCustomersLink">
                                Link Customers
                            </button>
                            <data-table
                                    :headings="companiesToLinkToDiscountGroupHeadings"
                                    :data="customerDiscountGroupAddEditForm.customerDiscountGroup.linkedCustomers.value"
                                    :hasActions="true"
                                    :hasCustomActionComponent="true"
                                    :hasNoFilter="true"
                                    :hasNoPaging="true">
                                <template #actionComponent="{ companyId }">
                                    <button class="btn btn-link" @click.prevent="onCustomerUnlink(companyId)">
                                        Unlink
                                    </button>
                                </template>
                            </data-table>
                        </div>

                        <div>
                            <h5>Link Products to Depot Discount Group</h5>
                            <div class="text-danger">
                                {{customerDiscountGroupAddEditForm.customerDiscountGroup.linkedProducts.errorMessage}}
                            </div>
                            <button class="btn btn-primary float-right" @click.prevent="onLinkProductsClick">
                                Link Products
                            </button>
                            <data-table
                                    :headings="productsToLinkHeadings"
                                    :data="customerDiscountGroupAddEditForm.customerDiscountGroup.linkedProducts.value"
                                    :hasActions="true"
                                    :hasCustomActionComponent="true"
                                    :hasNoFilter="true"
                                    :hasNoPaging="true">
                                <template #actionComponent="{ productId }">
                                    <button class="btn btn-link" @click.prevent="onProductUnlink(productId)">
                                        Unlink
                                    </button>
                                </template>
                            </data-table>
                        </div>

                        <button class="btn btn-primary mr-2" :disabled="loading">Save</button>
                        <button class="btn btn-secondary" @click.prevent="onBackClick" :disabled="loading">Back</button>
                    </form>
                </div>
                <loading-spinner :showSpinner="loadingFromApi"></loading-spinner>
            </div>
        </div>
    </div>

    <error-modal :modalHeading="errorModal.modalHeading"
                 :elementId="errorModal.elementId"
                 :modalMessage="errorModal.modalMessage"
                 :showModal="errorModal.showModal"
                 @okClicked="errorModelOkClicked"></error-modal>

    <success-modal
            :modalHeading="successModal.modalHeading"
            :elementId="successModal.elementId"
            :modalMessage="successModal.modalMessage"
            :showModal="successModal.showModal"
            @okClicked="successModelOkClicked"></success-modal>

    <link-customer-to-depot-discount-group-modal
            :heading="linkCustomersToDiscountGroupModal.heading"
            :modalId="linkCustomersToDiscountGroupModal.modalId"
            :showModal="linkCustomersToDiscountGroupModal.showModal"
            :customerDiscountGroupId="customerDiscountGroupAddEditForm.customerDiscountGroup.customerDiscountGroupId"
            :unlinkedCompanyId="companyIdThatWasUnlinked"
            @okClicked="onLinkCustomersToDiscountGroupModalOkClick"
            @onCustomersLinkedOrUnlinked="onCustomersLinkedOrUnlinked"></link-customer-to-depot-discount-group-modal>
    
    <link-products-to-customer-depot-discount-group-modal
            :heading="linkProductsToDiscountGroupModal.heading"
            :modalId="linkProductsToDiscountGroupModal.modalId"
            :showModal="linkProductsToDiscountGroupModal.showModal"
            :customerDiscountGroupId="customerDiscountGroupAddEditForm.customerDiscountGroup.customerDiscountGroupId"
            :discountAmount="customerDiscountGroupAddEditForm.customerDiscountGroup.discountAmount.value"
            :unlinkedProductId="productIdThatWasUnlinked"
            :depotId="customerDiscountGroupAddEditForm.customerDiscountGroup.depotId.value"
            @okClicked="onLinkProductsToCustomerGroupModalOkClick"
            @onProductsLinkedOrUnlinked="onProductsLinkedOrUnlinked"></link-products-to-customer-depot-discount-group-modal>

</div>
